export default {
  setCurrentTab (state, newTab) {
    state.currentTab = newTab
  },
  setWidgetToUpdate (state, widgetToUpdate) {
    state.widgetToUpdate = widgetToUpdate
  },
  setActiveToolbarItem (state, activeToolbarItem) {
    state.activeToolbarItem = state.toolbarItems[activeToolbarItem]
  },
  removeActiveToolbarItem (state) {
    state.activeToolbarItem = ''
  },
  setAuthStateChecked (state, val) {
    state.authStateChecked = val
  },
  setUserId (state, val) {
    state.userId = val
  },
  setCustomJs (state, payload) {
    if (payload.scoped) {
      if (state.scopedCustomJs === payload.code) return
      state.scopedCustomJs = payload.code
    } else {
      if (state.globalCustomJs === payload.code) return
      state.globalCustomJs = payload.code
    }
  },
  setDashboardLoadingStatus (state, val) {
    state.dashboardNotRendered = val
  },
  setDashboardModels (state, val) {
    state.dashboardModels = val
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations/other.js